import React from 'react';
import MiniCart from '../Components/HeaderButtons/MiniCart';
import Navigation from '../Components/HeaderButtons/Navigation';
import useIsAuthenticated from '../Hooks/useIsAuthenticated';
import { components } from '../Components/HeaderButtons/utils/Components';
import useEcommerceDisabled from '../Hooks/useEcommerceDisabled';

const HeaderButtonContainer = ({ buttons }) => {
  const isAuthenticated = useIsAuthenticated();
  const ecommerceDisabled = useEcommerceDisabled();

  return (
    <>
      {buttons &&
        !!buttons.length &&
        buttons.map((button) => {
          const ButtonComponent = components[button.component];

          const shouldRenderButton =
            !button.authenticatedOnly ||
            (button.authenticatedOnly && isAuthenticated);

          return shouldRenderButton && ButtonComponent ? (
            <ButtonComponent key={button.component} />
          ) : null;
        })}
      {!ecommerceDisabled && isAuthenticated && <MiniCart />}
      <Navigation />
    </>
  );
};

export default HeaderButtonContainer;
